import { useRegisterSW } from 'virtual:pwa-register/react';

const CHECK_EVERY_MS = 60 * 60 * 1000;

/** Rejestruje service worker i co godzinę sprawdza nową wersję (autoUpdate przeładuje stronę sam). */
export function UpdatePrompt() {
  useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => {
        if (navigator.onLine) void registration.update();
      }, CHECK_EVERY_MS);
    },
  });
  return null;
}
